import script from "./GuideView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideView.vue?vue&type=script&setup=true&lang=ts"

import "./GuideView.vue?vue&type=style&index=0&id=00cfb83a&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/jenkins_home/workspace/QuickApp_NapH5_YQZK_YiZhiAiChong/yzac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cfb83a"]])

export default __exports__